module.exports = "<div class=\"snackbar-main\">\r\n  <span class=\"ion-{{ type }}\"></span>\r\n  <p>{{ message }}</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/custom-snackbar/custom-snackbar.component.html
// module id = ../../../../../src/app/_shared/layout/custom-snackbar/custom-snackbar.component.html
// module chunks = main